import { useNavigate } from "react-router-dom"
import type { RouteView } from "../contract"
import { track } from "@/lib/analytics"

const enc = encodeURIComponent

/**
 * A question that is a notice or an order (attached, or pasted in): research does not read it, its
 * own door does (nira/agent/route.py). One plain line, the door, and the way back to a question on
 * the law.
 */
export function RouteCard({ route, onWithout, onDoor }: {
  route: RouteView
  onWithout?: () => void
  /** On the home page: open the door in place (it reads ?door= only when it loads). */
  onDoor?: (door: "notice" | "appeal") => void
}) {
  const navigate = useNavigate()
  const notice = route.to === "notice"
  const go = () => {
    track("research_routed_go", { to: route.to, why: route.why })
    if (route.case_id) navigate(`/case/${enc(route.case_id)}/confirm${notice ? "" : "?for=appeal"}`)
    else if (onDoor) onDoor(route.to)
    else navigate(`/ask?door=${notice ? "notice" : "appeal"}`)
  }
  return (
    <div className="nr-route" role="status">
      <p className="nr-route-t">{notice ? "This is a notice to analyse" : "This is an order to read for an appeal"}</p>
      <p className="nr-route-s">{route.message}</p>
      <div className="nr-route-acts">
        <button type="button" className="nr-route-go" onClick={go}>
          {notice ? "Analyse the notice" : "Read the order for an appeal"}
        </button>
        {onWithout ? (
          <button type="button" className="nr-route-alt" onClick={onWithout}>
            {route.why === "document" ? "Ask on the law, without it" : "Edit the question"}
          </button>
        ) : null}
      </div>
    </div>
  )
}
